export const defaultCommunityTemplate = {
  id: 'default-community',
  name: 'Creator Community',
  description: 'A modular hub for public fans, close friends, donors, and staff.',
  tiers: [
    {
      id: 'public',
      label: 'Public Plaza',
      visibility: 'public',
      badgeColor: 'from-blue-500 to-cyan-500',
      description: 'Open to everyone. Great for announcements and first contact.',
      requirementLabel: 'Anyone can see this',
      channels: [
        { id: 'public-welcome', name: 'welcome', emoji: '👋', type: 'text', topic: 'Start here: Rules & Verification' },
        { id: 'public-announcements', name: 'announcements', emoji: '📢', type: 'text', topic: 'Official updates' },
        { id: 'public-general', name: 'general-chat', emoji: '💬', type: 'text', topic: 'Say hello, share ideas' },
        { id: 'public-stage', name: 'community-stage', emoji: '🎙️', type: 'voice', topic: 'Town halls & all-hands' }
      ]
    },
    {
      id: 'followers',
      label: 'Followers Lounge',
      visibility: 'followers',
      badgeColor: 'from-purple-500 to-pink-500',
      description: 'Reward people who hit the follow button.',
      requirementLabel: 'Requires Following',
      channels: [
        { id: 'followers-highlights', name: 'behind-the-scenes', emoji: '🎬', type: 'text', topic: 'Sneak peeks + polls' },
        { id: 'followers-watch', name: 'watch-party', emoji: '🍿', type: 'voice', topic: 'Group streams & reactions' }
      ]
    },
    {
      id: 'friends',
      label: 'Friends HQ',
      visibility: 'friends',
      badgeColor: 'from-emerald-500 to-lime-500',
      description: 'Mutuals and collaborators hangout here.',
      requirementLabel: 'Mutual Follow Only',
      channels: [
        { id: 'friends-ops', name: 'ops-board', emoji: '🧩', type: 'text', topic: 'Roadmap, tasks, coordination' },
        { id: 'friends-sync', name: 'sync-room', emoji: '🗣️', type: 'voice', topic: 'Weekly sync calls' }
      ]
    },
    {
      id: 'donors',
      label: 'Donor Suite',
      visibility: 'donors',
      badgeColor: 'from-amber-500 to-orange-500',
      description: 'Investors, patrons, believers.',
      requirementLabel: 'Active donor/subscriber',
      channels: [
        { id: 'donor-alpha', name: 'alpha-reports', emoji: '📈', type: 'text', topic: 'Impact reports & drops' },
        { id: 'donor-board', name: 'board-room', emoji: '🏛️', type: 'voice', topic: 'Quarterly briefings' }
      ]
    },
    {
      id: 'moderators',
      label: 'Moderator Ops',
      visibility: 'moderators',
      badgeColor: 'from-rose-500 to-red-500',
      description: 'Keep the community safe + on-brand.',
      requirementLabel: 'Moderator access',
      channels: [
        { id: 'mods-log', name: 'incident-log', emoji: '🛡️', type: 'text', topic: 'Reports & actions' },
        { id: 'mods-standup', name: 'mod-standup', emoji: '📣', type: 'voice', topic: 'Daily standups' }
      ]
    },
    {
      id: 'staff',
      label: 'Core Staff',
      visibility: 'staff',
      badgeColor: 'from-slate-600 to-slate-800',
      description: 'Internal planning, finance, and launch readiness.',
      requirementLabel: 'Staff credentials',
      channels: [
        { id: 'staff-war', name: 'war-room', emoji: '⚔️', type: 'text', topic: 'Crisis + launches' },
        { id: 'staff-ops', name: 'ops-voice', emoji: '📞', type: 'voice', topic: 'Command channel' }
      ]
    }
  ]
};
